<script>
/**
 * A visão COMPLETA do índice "Artefatos desta conversa" (~360px): uma linha
 * por artefato = o `artefato-preview-card` em modo `mini` (tile do módulo,
 * título, subtítulo, "agora / há 4 min").
 *
 * ★ Viva no código, FORA da UI (decisão do usuário, 14/09/2026: "só chip e
 * modo denso"). Mora num componente irmão para o `chat-indice-artefatos.vue`
 * ficar só com o que a tela usa (chip + condensada) sem perder esta visão: o
 * pai a monta por `visao === VISOES_DO_INDICE.completa`, que hoje só o
 * `alternarDensidade()` dele (sem botão) alcança. Para voltar: trocar
 * `VISAO_ABERTA_PADRAO` no pai e/ou devolver ao cabeçalho dele um `<button>`
 * chamando `alternarDensidade` (ícone `task`, copy nova em `INDICE_ARTEFATOS`).
 *
 * Componente BURRO, como o pai: recebe as `linhas` já decoradas (o computed
 * `linhas` do pai) e emite `abrir(linha)` ou `fechar`. Quem decide o toggle
 * é o card mini (`artefato-preview-card.vue::onAbrir` compara a própria
 * identidade com `artefatoIdentidadeAtiva` no store): linha JÁ ativa emite
 * `fechar`. O pai traduz `abrir(linha)` para `{identidade, parteReal}`.
 *
 * A casca da lista (reset, `max-height`, rolagem) é a classe
 * `chat-indice-artefatos__lista` que o pai passa no root — o `<style scoped>`
 * do pai alcança o root do filho. Aqui mora só o que é desta visão.
 *
 * Sem `?.`/`??` (o Babel deste projeto não transpila). Acentos UTF-8 reais.
 */
import ArtefatoPreviewCard from '@modules/aawz-intelligence-v2/ui-registry/artefato-preview-card.vue'

const STORE_MODULE = 'aawz-intelligence-v2'

// Largura da completa — fixa, a mesma do popover que existiu antes (as linhas
// não dançam conforme o título mais longo). Quem aplica é o pai, no cartão
// (`estiloDoCartao`): o cartão e o cabeçalho são dele.
export const LARGURA_COMPLETA = 360

export default {
  name: 'IntelligenceV2ChatIndiceArtefatosCompleta',
  components: { ArtefatoPreviewCard },
  props: {
    // `[{identidade, titulo, icone, subtitulo, tempo, parteReal, ativa}]` — o
    // computed `linhas` do `chat-indice-artefatos.vue`.
    linhas: {
      type: Array,
      default: function () {
        return []
      },
    },
    // Repassada ao card mini — ver a prop homônima em
    // `artefato-preview-card.vue`. Default = o módulo fixo, como sempre foi.
    storeModule: {
      type: String,
      default: STORE_MODULE,
    },
  },
  methods: {
    abrir(linha) {
      this.$emit('abrir', linha)
    },
    fechar() {
      this.$emit('fechar')
    },
  },
}
</script>

<template>
  <!-- O card mini lê `artefatoIdentidadeAtiva` do store sozinho — a linha
       ativa (tile sólido, fundo destacado, `aria-current`, o "Fechar" no
       hover) e o toggle saem dele. -->
  <ul class="chat-indice-artefatos-completa" data-test="chat-indice-artefatos-completa">
    <li v-for="linha in linhas" :key="linha.identidade" class="px-2">
      <ArtefatoPreviewCard
        mini
        :identidade="linha.identidade"
        :store-module="storeModule"
        :titulo="linha.titulo"
        :icone="linha.icone"
        :subtitulo="linha.subtitulo"
        :tempo="linha.tempo"
        @abrir="abrir(linha)"
        @fechar="fechar"
      />
    </li>
  </ul>
</template>

<style lang="sass" scoped>
// Cada linha na largura toda (o `--mini` solta o teto de 50% do card, mas o
// `width: 100%` dele é sobre o `li`). O reset/rolagem da lista vem da classe
// do pai (ver o cabeçalho).
.chat-indice-artefatos-completa > li
  display: block
</style>
